import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=0afa80bd&scoped=true"
import script from "./taskList.vue?vue&type=script&lang=js"
export * from "./taskList.vue?vue&type=script&lang=js"
import style0 from "./taskList.vue?vue&type=style&index=0&id=0afa80bd&prod&lang=scss&scoped=true"
import style1 from "./taskList.vue?vue&type=style&index=1&id=0afa80bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa80bd",
  null
  
)

export default component.exports